<template>
  <div>
    <v-icon class="attachment-icon">attachment</v-icon>
    <a :href="attachmentUrl" target="_blank" class="ml-1 font600 attachment-link">{{
      attachmentName
    }}</a>
  </div>
</template>
<script>
export default {
  name: 'message-attachment',

  props: ['attachmentDetails'],

  computed: {
    attachmentUrl() {
      const {hotStorageUrl, contentUrl} = this.attachmentDetails || {};
      return hotStorageUrl || contentUrl || '';
    },
    attachmentName() {
      return this.attachmentDetails?.name || '';
    }
  }
};
</script>
<style scoped>
.attachment-link {
  color: #6888c9 !important;
  user-select: text;
}
</style>
